function accordion(){
    const triggers = window.document.querySelectorAll('.js_accordion-trigger');

    if(triggers.length < 1) return;

    triggers.forEach(trigger => {
        trigger.addEventListener('click',function(){
            if(window.innerWidth >= 769) return;
            const content = trigger.nextElementSibling;
            if( trigger.classList.contains('is-active')) {
                trigger.classList.remove('is-active');
                content.style.maxHeight = null;
            }
            else {
                trigger.classList.add('is-active');
                content.style.maxHeight = content.scrollHeight + "px";
            };
        })
    })
}
function accordionLg(){
    const triggers = window.document.querySelectorAll('.js_accordion-trigger-lg');

    if(triggers.length < 1) return;

    triggers.forEach(trigger => {
        trigger.addEventListener('click',function(){
            if(window.innerWidth >= 991) return;
            const content = trigger.nextElementSibling;
            if( trigger.classList.contains('is-active')) {
                trigger.classList.remove('is-active');
                content.style.maxHeight = null;
            }
            else {
                trigger.classList.add('is-active');
                content.style.maxHeight = content.scrollHeight + "px";
            };
        })
    })
}

window.addEventListener('load',accordion);
window.addEventListener('load',accordionLg);